import Icon from 'veui/components/Icon'

Icon.register({
  'exclamation-circle': {
    paths: [
      {
        d: 'M24 48a24 24 0 110-48 24 24 0 010 48zm0-4a20 20 0 100-40 20 20 0 000 40zm-2-32a2 2 0 114 0v16a2 2 0 11-4 0V12zm0 22a2 2 0 114 0v1a2 2 0 11-4 0v-1z'
      }
    ],
    width: '48',
    height: '48'
  }
})
